module.exports = __webpack_public_path__ + "img/info_14.5cf59028.png";